import { ChangeType, ContactPersonal, Customer, Issue, IssueCategory, IssueState, Priority, Location, Product, ContractState, ContractType, Address, ContactInformation } from './classes'

/**
 * @deprecated
 */
export const WistaAMSTypes = {
    ChangeType: 1,
    Issue: 2,
    IssuePriority: 3,
    IssueCategory: 4,
    Customer: 5,
    IssueState: 6,
    ContactPersonal: 7,
    IssueType: 8,
    IssueItem: 9,
    Change: 10,
    Incident: 11,
    Project: 12,
    Offer: 13,
    OfferItem: 14,
    Address: 15,
    ProductPicture: 16,
    ProductInGroup: 17,
    Contract: 18,
    CustomerContracts: 19,
    ContactInformation: 20,
    ContactInformationType: 21,
    ContractItem: 22,
    ContractState: 23,
    ContractType: 24,
    IssueOffers: 25,
    Location: 26,
    LocationAlias: 27,
    LocationAvailabilities: 28,
    Product: 29,
    CustomerOffers: 30,
    IssueTransaction: 31,
    IssueMails: 32
}
export const toStringCollection = [
    null,
    (a: ChangeType) => { return a.typename },
    (a: Issue) => { return a.issuenumber + " " + a.issuetitle },
    (a: Priority) => { return a.priorityname },
    (a: IssueCategory) => { return a.categoryname },
    (a: Customer) => { return a.customernumber + " " + a.customername },
    (a: IssueState) => { return a.statename },
    (a: ContactPersonal) => { return a? [a.contactperssalutation, a.contactpersfname, a.contactperslname].filter(x => x).join(' '): null },
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    (a: Address) => { return a.addressstreet + a.addresshousenumber },
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    (a: ContractState) => {
        return a.contractstatename;
    },
    (a: ContractType) => {
        return a.contracttypename;
    },
    null,
    (a: Location) => {
        if(a.address) return a.address.addressstreet + " " + a.address.addresshousenumber;
        else a.locationpart;
    },
    null,
    null,
    (a: Product) => { return a.productnumber + " " + a.productservice },
    null,
    (a: any) => { return a.name },
    (a: ContactInformation) => { return a.infovalue }
]